import { Typography, Button, Box, useTheme } from '@mui/material';
import { v4 as uuid } from 'uuid';

import { ScreenContainer } from 'src/components/flow';
import { Routes } from 'src/lib/constants';
import { EntityName, EventType } from 'src/utils/analytics/constants';

import type { FlowScreenProps } from './types';
import { useMemo } from 'react';
import { getNextQuestion } from 'src/redux/actions/form';
import { useAppDispatch } from 'src/redux/hooks';
import NextLink from 'next/link';
import { getActiveFlow } from 'src/redux/actions/flow';
import { Screen } from 'src/lib/flows/screens';

const WelcomeBackScreen: React.FC<FlowScreenProps> = ({ trackEvent }) => {
  const dispatch = useAppDispatch();
  const currentFlow = dispatch(getActiveFlow());
  const screen = currentFlow[Screen.WelcomeBack];
  const nextScreen = useMemo(
    () => dispatch(getNextQuestion(screen)),
    [dispatch, screen]
  );
  let resultsRedirectLink = Routes.Results;
  const trkLocationParam = `${
    resultsRedirectLink.includes('?') ? '&' : '?'
  }trk_location=cc_match_see_results`;
  (resultsRedirectLink as string) = `${resultsRedirectLink}${trkLocationParam}`;

  const handleRetakeQuizButton = () => {
    trackEvent(EventType.ElementInteracted, {
      interaction_id: uuid(),
      action: 'select',
      entity_name: EntityName.WelcomeBackRetake,
      interaction_type: 'press',
    });
  };

  const theme = useTheme();

  return (
    <ScreenContainer>
      <Box sx={{ textAlign: 'center', marginBottom: 4 }}>
        <Typography variant="h1">Hey there, welcome back!</Typography>
        <Typography variant="h1">
          Retake the quiz or see your previous results — it’s up to you.
        </Typography>
        <Box
          sx={{
            width: '90%',
            [theme.breakpoints.up('sm')]: { width: '40%' },
          }}
          component="img"
          alt=""
          src="https://www.nerdwallet.com/cdn/credit-cards-recommendation-client/welcome-back/result.svg"
        />
        <Box sx={{ [theme.breakpoints.up('sm')]: { marginTop: 1 } }}>
          <Button
            sx={{
              width: '100%',
              marginX: 2,
              [theme.breakpoints.up('sm')]: { width: '20%', marginX: 0 },
            }}
            component={NextLink}
            href={`${Routes.Flow}/${nextScreen}`}
            onClick={handleRetakeQuizButton}
            variant="outlined"
          >
            Retake Quiz
          </Button>
          <Button
            component={NextLink}
            href={resultsRedirectLink}
            sx={{
              width: '100%',
              marginTop: 3,
              marginX: 2,
              [theme.breakpoints.up('sm')]: {
                width: '20%',
                marginX: 2,
                marginTop: 0,
              },
            }}
          >
            See My Results
          </Button>
        </Box>
      </Box>
    </ScreenContainer>
  );
};

export default WelcomeBackScreen;
